import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import { SemanticUI } from '@iterable/deprecated_react_components';

export const StyledAccordion = styled(SemanticUI.Accordion)`
  &&& {
    margin: 0;
    user-select: none;
    border-radius: 0 !important;
    border: ${pxToRem(1)} solid #eff0f0;
    box-shadow: unset !important;
    .cssBasePanelTitle {
      padding: ${pxToRem(10)} ${pxToRem(15)} !important;
      > span {
        font-weight: 400;
      }
      &.active {
        > i,
        > span {
          color: #555;
        }
      }
    }
    .cssBasePanelContent {
      padding: ${pxToRem(10)} ${pxToRem(15)} !important;
      &.active {
        background-color: unset;
        border-radius: unset;
        padding: unset;
        box-shadow: unset;
        min-height: unset;
      }
    }
  }
`;
